import { moment } from "@msuite/utils/date";
import React from "react";
import type { ClassNameProps } from "../types";
import { AnimatedNumber } from "./animated-number";

/** Props Interface */
interface AnimatedDateProps extends ClassNameProps {
	input: string;
	inputFormat: string;
	outputFormat: string;
	splitValue: string;
}

export function AnimatedDate({
	input,
	inputFormat,
	outputFormat,
	splitValue,
	className,
}: AnimatedDateProps) {
	return (
		<div>
			{moment(input, inputFormat)
				.startOf("day")
				.format(outputFormat)
				.split(splitValue)
				.map((item, index) => {
					return (
						<React.Fragment key={index}>
							<AnimatedNumber
								continuous={false}
								value={Number.parseInt(item, 10)}
								className={className}
								format={{
									useGrouping: false,
									minimumIntegerDigits: 2,
								}}
							/>
							{index < 2 && <span className="text-gray-500">{splitValue}</span>}
						</React.Fragment>
					);
				})}
		</div>
	);
}
